module.exports = __webpack_public_path__ + "files/6b86ca084841235280f2893feeacb4d6.png";